/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// MWF Trust Badges + Urgency — injected by ATLAS
(function() {
  function injectElements() {
    var buyBtn = document.querySelector('.product-info__block-item--buy-buttons, [data-block-type="buy_buttons"]');
    if (!buyBtn) return;
    
    // Urgency (before buy button)
    if (!document.getElementById('mwf-urgency')) {
      var urgency = document.createElement('div');
      urgency.id = 'mwf-urgency';
      urgency.innerHTML = '<div style="background:rgba(255,69,0,0.12);border:1px solid rgba(255,100,50,0.4);border-radius:8px;padding:10px 14px;font-size:13px;color:#ff7043;font-weight:700;margin:10px 0;display:flex;align-items:center;gap:8px;">🔥 <span>HIGH DEMAND — Only a few left at this price. Order now to lock in your discount.</span></div>';
      buyBtn.parentNode.insertBefore(urgency, buyBtn);
    }
    
    // Trust badges (after buy button)
    if (!document.getElementById('mwf-trust')) {
      var trust = document.createElement('div');
      trust.id = 'mwf-trust';
      trust.innerHTML = '<div style="display:flex;flex-wrap:wrap;gap:12px;justify-content:center;padding:12px 0;border-top:1px solid rgba(255,255,255,0.1);margin-top:12px;"><span style="font-size:12px;color:#aaa;display:flex;align-items:center;gap:5px;">🔒 Secure Checkout</span><span style="font-size:12px;color:#aaa;display:flex;align-items:center;gap:5px;">🚚 Free US Shipping</span><span style="font-size:12px;color:#aaa;display:flex;align-items:center;gap:5px;">↩️ 30-Day Returns</span><span style="font-size:12px;color:#aaa;display:flex;align-items:center;gap:5px;">🏭 GMP Certified</span></div>';
      buyBtn.parentNode.insertBefore(trust, buyBtn.nextSibling);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectElements);
  } else {
    injectElements();
  }
  setTimeout(injectElements, 800);
})();


// MWF Announcement Bar — fix inflated numbers
(function() {
  function fixAnnouncementBar() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while (node = walker.nextNode()) {
      if (node.nodeValue && node.nodeValue.indexOf('57.819') !== -1) {
        node.nodeValue = node.nodeValue.replace(/57[\.\,]819/g, '16,400');
      }
      if (node.nodeValue && node.nodeValue.indexOf('MONTHLY ORDERS') !== -1) {
        node.nodeValue = node.nodeValue.replace('MONTHLY ORDERS DELIVERED AHEAD OF SCHEDULE', 'ORDERS DELIVERED ON TIME');
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAnnouncementBar);
  } else {
    fixAnnouncementBar();
  }
  setTimeout(fixAnnouncementBar, 500);
  setTimeout(fixAnnouncementBar, 1500);
})();
